import React, { useEffect } from 'react';
import './Legais.css';

function PoliticaPrivacidade() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legais-page">
            <div className="legais-container">
                <div className="legais-header">
                    <h1>Política Geral de Privacidade</h1>
                    <p>Respeito ao Produtor Rural e Segurança da Informação</p>
                </div>

                <div className="legais-section">
                    <h2>1. Abrangência e Consentimento</h2>
                    <p>Esta Política descreve de forma transparente como a plataforma <strong>Agroov</strong> coleta, armazena, utiliza e protege os dados pessoais de seus usuários. Ao se cadastrar e utilizar nossos serviços de marketplace e fretes, você declara estar ciente e consentir com as práticas aqui descritas.</p>
                    <p>A proteção da privacidade no campo é prioridade absoluta. Respeitamos o sigilo das suas informações comerciais e operacionais.</p>
                </div>

                <div className="legais-section">
                    <h2>2. Dados Coletados e Finalidade do Uso</h2>
                    <p>Para garantir uma experiência segura, o Agroov coleta os seguintes dados:</p>
                    <ul>
                        <li><strong>Dados Cadastrais:</strong> Nome completo, CPF/CNPJ, telefone de contato, endereço e e-mail. <em>Finalidade:</em> Identificação do usuário e emissão de faturas.</li>
                        <li><strong>Dados do Veículo:</strong> Placa, modelo e capacidade de carga (para transportadores). <em>Finalidade:</em> Validação de segurança e cálculo de rotas.</li>
                        <li><strong>Dados Financeiros:</strong> Histórico de pagamentos intermediados pelo gateway Mercado Pago. <em>Finalidade:</em> Efetivação de assinaturas PRO.</li>
                    </ul>
                </div>

                <div className="legais-section">
                    <h2>3. Compartilhamento Seguro de Dados</h2>
                    <p>O Agroov <strong>não comercializa</strong> dados pessoais. O compartilhamento ocorre exclusivamente para viabilizar os negócios:</p>
                    <ul>
                        <li>Dados de contato (e-mail e telefone) são fornecidos ao comprador e vendedor envolvidos em uma mesma negociação para fechamento do frete.</li>
                        <li>Dados obrigatórios exigidos por autoridades judiciais ou regulatórias brasileiras.</li>
                    </ul>
                </div>

                <div className="legais-section">
                    <h2>4. Segurança e Armazenamento</h2>
                    <p>Utilizamos criptografia de ponta a ponta no tráfego de dados e hospedagem em servidores em nuvem de alta segurança para prevenir vazamentos ou acessos não autorizados.</p>
                </div>
            </div>
        </div>
    );
}

export default PoliticaPrivacidade;
